import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';
import {RouterLink} from '@angular/router';
import {SpotfightEvent} from '../../core/models/models';
import {SpotfightDateFormatPipe} from '../../core/pipes/date-format/spotfight-date-format.pipe';
import {longTermEventStatus, LongTermEventStatus} from '../../core/models/event-status';

@Component({
  selector: 'app-compact-event-card',
  standalone: true,
  imports: [NgClass, RouterLink, SpotfightDateFormatPipe],
  templateUrl: './compact-event-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './compact-event-card.component.scss'
})
export class CompactEventCardComponent {
  @Input({required: true}) event!: SpotfightEvent;

  get eventStatus(): LongTermEventStatus {
    return longTermEventStatus(this.event);
  }

  get eventStatusLabel(): string {
    switch (this.eventStatus) {
      case 'open':
        return 'Offen';
      case 'running':
        return 'Auswertung ausstehend';
      case 'finished':
        return 'Beendet';
    }
  }
}
